import React from "react";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { MdOutlineEmail } from "react-icons/md";
import "animate.css/animate.min.css";
import "./Services.css";
import UXUI from "../../assets/designer.png";
import Design from "../../assets/responsive-design.png";
import Develop from "../../assets/development.png";
import { BsGearWideConnected } from "react-icons/bs";
import { FaCode, FaConnectdevelop, FaLaptopCode } from "react-icons/fa";
import "animate.css/animate.min.css";

function Services({ darkMode }) {
  return (
    <div id="services" className={darkMode ? "services" : "services light"}>
      <h5>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInLeftBig"
        >
          What Can I Bring For You
        </AnimationOnScroll>
      </h5>
      <h2>
        <AnimationOnScroll
          animateOnce="true"
          animateIn="animate__fadeInRightBig"
        >
          Services
        </AnimationOnScroll>
      </h2>
      <div className="service_options">
        <AnimationOnScroll
          initiallyVisible={true}
          animateIn="animate__rubberBand"
        >
          <article className="service__option">
            <div className="header">
              <img src={UXUI} alt="" />
            </div>
            <h3>UI / UX</h3>
            <small>
              We Offer A Full Service Communication Plan That Maximizes The
              Engagement Of Your Audience In The Japanese Market.
            </small>
            <div className="learn-more">
              <button className="btn btn-primary">Learn More</button>
            </div>
          </article>
        </AnimationOnScroll>
        <AnimationOnScroll
          initiallyVisible={true}
          animateIn="animate__rubberBand"
        >
          <article className="service__option">
            <div className="header">
              <img src={Develop} alt="" />
            </div>
            <h3>Web Development</h3>
            <small>
              Web development services help create all types of web-based
              software and ensure great experience for web users.
            </small>
            <div className="learn-more">
              <button className="btn btn-primary">Learn More</button>
            </div>
          </article>
        </AnimationOnScroll>
        <AnimationOnScroll
          initiallyVisible={true}
          animateIn="animate__rubberBand"
        >
          <article className="service__option">
            <div className="header">
              <img src={Design} alt="" />
            </div>
            <h3>Web Design</h3>
            <small>
              We provide extensive support in design, communication, and
              strategy to establish brands in both visual and storytelling.
            </small>
            <div className="learn-more">
              <button className="btn btn-primary">Learn More</button>
            </div>
          </article>
        </AnimationOnScroll>
      </div>
    </div>
  );
}

export default Services;
